import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import { FileDropZoneImage } from '../FileDropZoneImage';

import * as styles from './styles.css';

export const FileDropZone: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="file-drop-zone">
      <div className={styles['image']}>
        <FileDropZoneImage />
      </div>
      <ArticleHeading1>Вижу документ!</ArticleHeading1>
      <ArticleHeading1>Чтобы приложить, просто отпустите его</ArticleHeading1>
    </div>
  );
};

FileDropZone.displayName = 'FileDropZone';
